import { Injectable } from "@angular/core";
import { AuthService } from "@saliente/common-auth";
import { BehaviorSubject, from, Subscription } from "rxjs";
import { RestService } from "./rest.service";
import { GetClientDocumentsTotalStatisticsForContractGQL, GetSubscriptionBadgesGQL } from "src/app/client-contract/adapters/clientContract.generated";
import { SubscriptionBadgesModel } from "src/app/client-contract/client-contract.model";
import { plainToClass } from "class-transformer";

@Injectable()
export class ClientContractCommonService {
    public subscriptionBadges: BehaviorSubject<SubscriptionBadgesModel>;
	public subscriptionBadgesSubscription: Subscription;
    public statisticsForContract: BehaviorSubject<number>;
	public statisticsForContractSubscription: Subscription;

    constructor(private authService: AuthService, private restService: RestService) {
		this.subscriptionBadges = new BehaviorSubject<SubscriptionBadgesModel>(null);
		this.statisticsForContract = new BehaviorSubject<number>(null);
	}

    public async getSubscriptionBadgesData(clientEid: string): Promise<SubscriptionBadgesModel> {
		let qry = new GetSubscriptionBadgesGQL(this.restService);
		let queryData = await qry.fetch(
			{
				clientEid: clientEid,
			}
		).toPromise();

		if (queryData != null) {
			let result = plainToClass(SubscriptionBadgesModel, queryData.data.billing.getSubscriptionBadgesUsingGET);
			return result;
		}

		return null;
	}

	public getSubscriptionBadges() {
		if (this.subscriptionBadgesSubscription) { this.subscriptionBadgesSubscription.unsubscribe(); this.subscriptionBadgesSubscription = null; }

		if (this.authService.user && this.authService.user.selectedCompanyId) {
			this.subscriptionBadgesSubscription = from(this.getSubscriptionBadgesData(this.authService.user.selectedCompanyId)).subscribe((badges) => {
				if (badges != null) {
					this.subscriptionBadges.next(badges);
				}
			})
		}
	}

    public async getClientDocumentsTotalStatisticsForContractData(clientEid: string): Promise<number> {
		let qry = new GetClientDocumentsTotalStatisticsForContractGQL(this.restService);
		let queryData = await qry.fetch(
			{
				clientEid: clientEid,
			}
		).toPromise();

		if (queryData != null) {
			return queryData.data.documents.GetClientDocumentsTotalStatisticsUsingGET.contractNotExists;
		}

		return null;
	}

    public getClientDocumentsTotalStatisticsForContract() {
		if (this.statisticsForContractSubscription) { this.statisticsForContractSubscription.unsubscribe(); this.statisticsForContractSubscription = null; }

		if (this.authService.user && this.authService.user.selectedCompanyId) {
			this.statisticsForContractSubscription = from(this.getClientDocumentsTotalStatisticsForContractData(this.authService.user.selectedCompanyId)).subscribe((badges) => {
                if (badges != null) {
                    this.statisticsForContract.next(badges);
                }
			})
		}
	}

	public get extraCostCount(): number {
		if (this.subscriptionBadges != null && this.subscriptionBadges.value != null) {
			return this.subscriptionBadges.value.hasExtraCost ? 1 : 0;
		}
	}

	public get unpaidInvoiceCount(): number {
		if (this.subscriptionBadges != null && this.subscriptionBadges.value != null) {
			return this.subscriptionBadges.value.hasUnpaidInvoice ? 1 : 0;
		}
	}

    public get contractNotExistsCount(): number {
		if (this.statisticsForContract != null && this.statisticsForContract.value != null) {
			return this.statisticsForContract.value;
		}
	}
}
